import actions from 'react/api/actions/index';
import { fromJS } from 'immutable';

const { actions: footerActions } = actions.footer; 

const initialState = fromJS({
  suspenseActionsIsOpen: false,
  miniDashboardIsOpen: true,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case footerActions.toggleSuspenseActions: {
      const { payload: isOpen } = action;

      return state.set('suspenseActionsIsOpen', isOpen);
    }
    case footerActions.toggleMiniDashboard: {
      const { payload: isOpen } = action;

      return state.set('miniDashboardIsOpen', isOpen);
    }
    default:
      return state;
  }
};
